var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-preview-several-images" },
    [
      _vm._l(_vm.files, function(file, index) {
        return _c(
          "div",
          { key: index + _vm.listPreviewId, staticClass: "item-image" },
          [
            _c(
              "div",
              { staticClass: "img-preview-one-file-container" },
              [
                _c("b-img", {
                  staticClass: "img-preview-one-file cursor-pointer",
                  attrs: { src: file.url, alt: "Image" },
                  on: {
                    click: function($event) {
                      return _vm.openModal(file.url)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "delete-btn-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "action-btn delete cursor-pointer",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.deleteFile(index, $event)
                        }
                      }
                    },
                    [_c("i", { staticClass: "ph-custom ph-trash-bold" })]
                  )
                ])
              ],
              1
            )
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            centered: "",
            size: "lg",
            "hide-backdrop": "",
            "content-class": "p-0"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function($event) {
                          _vm.showModal = false
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "ph-custom ph-x-bold secondary-text-color"
                      })
                    ]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _vm._v(" "),
          _c("img", {
            staticClass: "w-100",
            attrs: { src: _vm.selectedImageUrl, alt: "Image agrandie" }
          })
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-280d5135", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-280d5135","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/showFields/PreviewSeveralImages.vue
// module id = EEVM
// module chunks = 0